// Project Table Types
export interface ProjectRowData {
  id: number;
  order_id: string;
  order_name: string;
  user_id: string;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  order_due_at: string | null;
  order_status_id: string | null;
  order_status_name: string | null;
  order_status_description: string | null;
  translation_type: string;
  translated_from: string;
  translated_to: string;
  page_count: string;
  words_count: string;
  documents: string;
  order_total: string;

  first_name: string;
  last_name: string;
  email: string;
  include_expedited_turnaround: string;
  include_2_day_shipping: string;
  include_mail_hard_copy: string;
  include_notarization: string;

  order_notes: string;
  project_description: string;
  address_fields: string;
  name_on_card: string | null;
  languages?: [string, string];
  manager?: boolean;
  translator?: string[];
  actionCol?: string;
  message_cnt?: number;
}

export interface ProjectTableProps {
  isFetching: boolean;
  tableData: ProjectRowData[];
  onShowCustomerProjectDetails: (projectId: string) => void;
  pageLimit: number;
  onRefresh?: () => void;
  tabIndex?: number;
}

export interface StatusColors {
  bg: string;
  text: string;
}

export const MOBILE_COLUMN_WIDTHS = {
  order_name: 200,
  order_status_name: 200,
  languages: 160,
  manager: 60,
  translator: 200,
  order_due_at: 120,
  actionCol: 160,
} as const;
